var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 8.25H3.45C3.02996 8.25 2.81994 8.25 2.65951 8.33175C2.51839 8.40365 2.40365 8.51839 2.33175 8.65951C2.25 8.81994 2.25 9.02996 2.25 9.45V15.75M12.375 8.25H14.55C14.97 8.25 15.1801 8.25 15.3405 8.33175C15.4816 8.40365 15.5963 8.51839 15.6683 8.65951C15.75 8.81994 15.75 9.02996 15.75 9.45V15.75M12.375 15.75V4.65C12.375 3.80992 12.375 3.38988 12.2115 3.06901C12.0677 2.78677 11.8382 2.5573 11.556 2.41349C11.2351 2.25 10.8151 2.25 9.975 2.25H8.025C7.18492 2.25 6.76488 2.25 6.44401 2.41349C6.16177 2.5573 5.9323 2.78677 5.78849 3.06901C5.625 3.38988 5.625 3.80992 5.625 4.65V15.75M16.5 15.75H1.5M8.25 5.25H9.75M8.25 8.25H9.75M8.25 11.25H9.75",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.0dd35798964887d10fd989646ae98df6.svg";
export { ForwardRef as ReactComponent };